// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3VHvP","actionsCol":"EnrolledClinics_actionsCol__3dZk0"};